import { HelperConfig, Helpers } from "./Helpers"

export class HelperState{
    setter:Function
    helpers:HelperConfig[]
    constructor(setter:Function){
      this.setter = setter
      this.helpers = Helpers.getHelpers().concat()
    }
    openHelper = (helperIndex:number) => {
      const opener = (state:HelperState)=>{
        const freshHelpers:HelperConfig[] = state.helpers.concat()
        const helper:HelperConfig = freshHelpers[helperIndex]
        helper.displayOrder = Date.now()
        return{helpers:freshHelpers}
      }
      this.setter(opener)
    }
    openAllHelpers = () => {
      const opener = (state:HelperState)=>{
        const freshHelpers:HelperConfig[] = state.helpers.concat()
        freshHelpers.forEach((helper:HelperConfig, index:number)=>{
          helper.displayOrder = Date.now() + index
        })
        return{helpers:freshHelpers}
      }
      this.setter(opener)
    }
    openOnlyHelpersByTitle = (helperTitles:string[]) => {
      const opener = (state:HelperState)=>{
        const freshHelpers:HelperConfig[] = state.helpers.concat()
        freshHelpers.forEach((helper:HelperConfig)=>{
          if(helperTitles.includes(helper.title)){
            helper.displayOrder = Date.now()
          }
          else{
            helper.displayOrder = 0
          }
        })
        return{helpers:freshHelpers}
      }
      this.setter(opener)
    }
    closeHelperByIndex = (index:number) => {
        const closer = (state:HelperState)=>{
          const freshHelpers:HelperConfig[] = state.helpers.concat()
          const helper:HelperConfig = freshHelpers[index]
          helper.displayOrder = 0
          return{helpers:freshHelpers}
        }
      this.setter(closer)
    }
    closeHelper = (helperTitle:string) => {
      const closer = (state:HelperState)=>{
        const freshHelpers:HelperConfig[] = state.helpers.concat()
        freshHelpers.forEach((helper:HelperConfig)=>{
          if(helperTitle === helper.title){
            helper.displayOrder = 0
          }
        })
        return{helpers:freshHelpers}
      }
      this.setter(closer)
    }
    closeAllHelpers = () => {
      const closer = (state:HelperState)=>{
        const freshHelpers:HelperConfig[] = state.helpers.concat()
        freshHelpers.forEach((helper:HelperConfig)=>{
            helper.displayOrder = 0
        })
        return{helpers:freshHelpers}
      }
      this.setter(closer)
    }
    setState = (obj:any) => {
      this.setter((state:HelperState) => (obj))
    }
  }